import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import RampDetail from '@app/pages/customer/RampDetail/RampDetail.tsx';

const RampDetailPage = () => {
  const { tr } = useTranslationLgs();
  const { id, rampId } = useParams();

  return (
    <>
      {id && rampId && (
        <ResponsiveLayout title={tr('RampDetail.rampDetail', 'Ramp detail')}>
          <RampDetail locationId={id as string} rampId={rampId as string} />
        </ResponsiveLayout>
      )}
    </>
  );
};

export default withAuthenticationRequired(RampDetailPage);
